import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import InlineText from '@/design_system/Typography/InlineText';
import IconShipmentDone from '@/icons/ShipmentDone.svg';
import { SHIPMENT_CARRIERS } from '@/models/shipment';

export const ShipmentTransitCompletedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'shipment_transit_completed'>;
}) => {
  const { i18n } = useLingui();
  let creatorName = '';

  if (activity.shipment.carrier === 'private-carrier') {
    creatorName = i18n._(
      msg({
        id: 'activities.shipment_transit_completed.private-carrier',
        message: 'A private carrier',
      })
    );
  } else {
    creatorName =
      SHIPMENT_CARRIERS.find((c) => c.id === activity.shipment.carrier)?.name ??
      activity.shipment.carrier ??
      '';
  }

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconShipmentDone />}
      message={
        <BaseActivityText>
          <Trans id="activities.shipment_transit_completed.message">
            <strong>{creatorName}</strong> delivered the package to{' '}
            <InlineText weight="medium">
              {activity.shipment.destinationAddress?.contactName}
            </InlineText>
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
